import React from 'react';

interface Props {
	reload?: () => void;
	text?: React.ReactNode;
	caption?: string;
	className?: string;
}

export const LoadingError: React.FC<Props> = ({
	reload,
	text = 'Oops, Something went wrong...',
	caption = 'try load again',
	className = 'editable-table-error info-block',
}) => {
	return <div className={className}>
		<i className="fa fa-exclamation-triangle" aria-hidden="true" />
		<div>{text}</div>
		{reload && <a
			style={{ cursor: 'pointer' }}
			onClick={(e) => {
				e.preventDefault();
				reload();
			}}
		>
			{caption}
		</a>}
	</div>;
};
